// Re-exports from unified color system
import { useMemo } from 'react';
import { MOBILE_LIGHT_COLORS } from '../residentColors';
import { useThemeColors } from '@/hooks/residents/useThemeColors';

export const RESIDENTS_MOBILE_COLORS = {
  BACKGROUND_PRIMARY: MOBILE_LIGHT_COLORS.background,
  TEXT_PRIMARY: MOBILE_LIGHT_COLORS.textPrimary,
  TEXT_SECONDARY: MOBILE_LIGHT_COLORS.textSecondary,
  TEXT_TERTIARY: MOBILE_LIGHT_COLORS.textTertiary,
  BUTTON_PRIMARY: MOBILE_LIGHT_COLORS.buttonPrimary,
  BUTTON_SECONDARY: MOBILE_LIGHT_COLORS.buttonSecondary,
  BORDER_PRIMARY: MOBILE_LIGHT_COLORS.borderPrimary,
  AVATAR_BACKGROUND: MOBILE_LIGHT_COLORS.avatarBackground,
} as const;

export function useMobileColors() {
  const { semantic, components, colors } = useThemeColors();
  return useMemo(() => ({
    BACKGROUND_PRIMARY: semantic.background.primary,
    TEXT_PRIMARY: semantic.text.primary,
    TEXT_SECONDARY: semantic.text.secondary,
    TEXT_TERTIARY: semantic.text.tertiary,
    BUTTON_PRIMARY: semantic.interactive.primary,
    BUTTON_SECONDARY: semantic.interactive.secondary,
    BORDER_PRIMARY: semantic.border.secondary,
    AVATAR_BACKGROUND: components.avatar.background,
  }), [semantic, components, colors]);
}
